import * as React from 'react';
import TerminalInstallationListAddForm from './../Layout/Form/TerminalInstallationListAddForm';
import TerminalInstallationListSetDateForm from './../Layout/Form/TerminalInstallationListSetDateForm';
import {News} from 'Redux/Actions/Models/ErrorActionModel';
import {setNewsForMoment} from 'Redux/Actions/ErrorActions';
import * as TIModule from '../../Modules/TerminalInstallationModule';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {TerminalInstallationSelectors} from 'Redux/Selectors/TerminalInstallationSelectors';
import * as UserModule from 'Modules/UserModule';
import {checkPageQuery} from 'HelperFunctions/Lists';
import {createSerachQuery} from 'Connectors/_main';

type Props = {
    history?: any;
    match: any;
};

type ConnectedDispatch = {
    setNews: (news: News) => Function;
    getTerminallInstalationById: (id: number) => Function;
    setTerminallInstalationOneElement: (terminaInstalationDto: TIModule.Types.TerminalInstallationOrderDto) => Function;
    editTerminallInstalationOrder: (formData: TIModule.Types.EditTerminalInstallationRequest, id: number) => Function;
    setDateTerminallInstalationOrder: (formData: TIModule.Types.SetDateTerminalInstallationRequest, id: number) => Function;
    getTechnicianList: Function;
};

type ConnectedProps = {
    t?: Function;
    terminalInstallationOneElement?: TIModule.Types.TerminalInstallationOrderDto;
    terminalInstallationOneElementBySetDateForm?: TIModule.Types.SetDateTerminalInstallationForm;
};

type State = {};

class TerminalInstallationSetDate extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async componentDidMount() {
        if (this.props.match.params.terminalInstallationId) {
            await this.props.getTerminallInstalationById(this.props.match.params.terminalInstallationId);
        }

        const tempFiltered = new Array();
        tempFiltered.push({
            id: 'validInsurance',
            value: true
        });
        tempFiltered.push({
            id: 'criminalBackgroundCheck',
            value: true
        });
        tempFiltered.push({
            id: 'status',
            value: UserModule.UserEnumTypes.Status.ACTIVE
        });
        const query = checkPageQuery(tempFiltered, null);
        const params: any = createSerachQuery(query);
        this.props.getTechnicianList(params);
    }

    public async handleSubmit(formData: TIModule.Types.SetDateTerminalInstallationForm) {
        const formTemp: TIModule.Types.SetDateTerminalInstallationRequest = {
            technicianUserId: formData.technicianUser?.value,
            installationDate: formData.installationDate ?? undefined
        };
        this.props.setDateTerminallInstalationOrder(formTemp, this.props.match.params.terminalInstallationId);
    }

    public render() {
        return (
            <div className="main__content main__content--scroll" data-testid="installation-date-form">
                <h3 className="form__title">
                    {this.props.t('setDateTerminalInstallation')}
                </h3>
                <div className="form--flex">
                    <div className="form__col form__col--order-1">
                        <TerminalInstallationListAddForm
                            initialValues={this.props.terminalInstallationOneElement}
                            {...{
                                typeForm: 'setDate',
                                hideTitle: true
                            }}
                        />
                    </div>
                    <div className="form__col">
                        <TerminalInstallationListSetDateForm
                            onSubmit={this.handleSubmit}
                            initialValues={this.props.terminalInstallationOneElementBySetDateForm}
                            {...{
                                typeForm: 'setDate'
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    public componentWillUnmount() {
        this.props.setTerminallInstalationOneElement(null);
    }
}

function mapStateToProps(state: RootState) {
    return {
        terminalInstallationOneElement: state.terminalInstallationStore.terminalInstallationOneElement,
        terminalInstallationOneElementBySetDateForm: TerminalInstallationSelectors.getTerminalInstallationOneElementBySetDateForm(state)
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        setNews: (news: News) => dispatch(setNewsForMoment(news)),
        getTerminallInstalationById: (terminallInstalationId: number) => dispatch(TIModule.Actions.getTerminallInstalationById(terminallInstalationId)),
        setTerminallInstalationOneElement: (terminaInstalationDto: TIModule.Types.TerminalInstallationOrderDto) => dispatch(TIModule.Actions.setTerminallInstalationOneElement(terminaInstalationDto)),
        editTerminallInstalationOrder: (formData: TIModule.Types.EditTerminalInstallationRequest, id: number) => dispatch(TIModule.Actions.editTerminallInstalationOrder(formData, id)),
        setDateTerminallInstalationOrder: (formData: TIModule.Types.SetDateTerminalInstallationRequest, id: number) => dispatch(TIModule.Actions.setDateTerminallInstalationOrder(formData, id)),
        getTechnicianList: (queryParams?: URLSearchParams) => dispatch(TIModule.Actions.getTechnicianList(queryParams))
    };
}

export default withTranslation(['forms', 'errors', 'dictionary'])(connect(
    mapStateToProps,
    mapDispatchToProps
)(TerminalInstallationSetDate) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/TerminalInstallation/TerminalInstallationSetDate.tsx